import React from "react";
import { Link } from "react-router-dom";

export default function ErrorPage() {
  return (
    <main className="page" dir="rtl">
      <section className="panel">
        <img src="/logo.png" alt="Blue Parking" className="logo" />
        <h1>התשלום לא הושלם</h1>
        <p>ניתן לחזור ולנסות שוב.</p>
        <Link to="/">חזרה להתחלה</Link>
      </section>
    </main>
  );
}
